<template>
  <ul class="nav navbar-nav navbar-right">
    <!-- <router-link to="/percurso" tag="li"><a>Percurso</a></router-link> -->
    <!-- <router-link to="/regulamento" tag="li"><a>Regulamento</a></router-link> -->
    <li><a href="/doc/regulamento.pdf" target="_blank">Regulamento</a></li>
    <!-- <router-link to="/inscricao" tag="li"><a>Inscrição</a></router-link> -->
    <router-link to="/lista-inscritos" tag="li"><a>Lista Inscritos</a></router-link>
    <router-link to="/tempo" tag="li"><a>Tempo</a></router-link>
    <router-link to="/resultados" tag="li"><a>Resultados</a></router-link>
    <!-- <router-link to="/contacto" tag="li"><a>Contacto</a></router-link> -->
  </ul>
</template>

<script>
export default {
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Nav.vue?16c753d6